import Button from "@material-ui/core/Button";
import type { Theme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { Order } from "../../../models/order";
import { Page } from "../../../models/page";
import { getUserOrders } from "../../../models/user";
import Table from "../../OrderList/Table";

const useStyles = makeStyles((theme: Theme) => ({
  buttonContainer: {
    display: "flex",
    marginTop: theme.spacing(3),
  },
  hasPrevNext: {
    justifyContent: "space-between",
  },
  hasNext: {
    justifyContent: "flex-end",
  },
}));

export default function OrderList({ uid }: { uid: string }) {
  const classes = useStyles();

  const [orders, setOrders] = useState<Order[]>([]);
  const [page, setPage] = useState<Page>({});
  const [nowPage, setNowPage] = useState<number>(1);

  useEffect(() => {
    getUserOrders(uid, nowPage).then(({ orders, page }) => {
      setOrders(orders);
      setPage(page);
    }, console.error);
  }, [uid, nowPage]);

  const handleNext = () => {
    if (page?.next) {
      setNowPage(page.next);
    }
  };
  const handlePrev = () => {
    if (page?.prev) {
      setNowPage(page.prev);
    }
  };

  return (
    <div>
      <Table orders={orders} />
      {page && (
        <div
          className={clsx(classes.buttonContainer, {
            [classes.hasPrevNext]: page.prev && page.next,
            [classes.hasNext]: !page.prev && page.next,
          })}
        >
          {page.prev && (
            <Button color="default" variant="contained" onClick={handlePrev}>
              前へ
            </Button>
          )}
          {page.next && (
            <Button color="default" variant="contained" onClick={handleNext}>
              次へ
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
